import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from './icons';

import '../styles/wifi_view.scss';

class WifiView extends React.Component{


	render(){
		return (<div className="wifi-view">
			<div className="logo-icon">
				<Iconset.logo />
			</div>
			<div className="wifi-view-holder">
				<div className="wifi-view-block">
					<div className="ico cellular">
						<Iconset.cellularIcon />
					</div>
					<p>We recommend using a wifi connection to save on cellular data.</p>
				</div>
				{(this.props.orientation == 0) && 
					<div className="wifi-view-block turn">
						<div className="ico turn">
							<Iconset.turnIco />
						</div>
						<p>Please rotate your screen to start.</p>
					</div>
				}
					</div>
			</div>);
	}
}

export default WifiView;


// WEBPACK FOOTER //
// ./src/scripts/wifi.js